<div class='container-fluid'>
  <div class='row ms-2 '>
    <mat-form-field appearance="fill" class=' mt-3 col-md-3 col-12  my-auto custom-select-like-dropdown' >
      <mat-label>{{ 'website.equipment.config.performance.consumers' | translate }}</mat-label>
      <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
      <mat-select (selectionChange)='handleSelectChange($event)'>
        <mat-option *ngFor="let series of allData" [value]="series.id">
          {{series.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class='col-md-6 my-auto pb-2'>
      <span style='font-family: Montserrat, sans-serif;font-weight: 600; margin-top:-20px;'>{{minDateSelected | localDate}}</span>
    </div>
  </div>
</div>


<mat-dialog-content >
  <div class='container-fluid'>
    <div class='row'>
      <span  class='title'>{{ 'website.equipment.config.performance.engine_startup' | translate }}</span>
    </div>
    <div class='row'>
      <app-equipment-performances-charts
        [data]='currentData'
        [minDate]='minDateSelected'
        [maxDate]='maxDateSelected'
        [height]='150'
        [plotWidth]='600'
      ></app-equipment-performances-charts>
    </div>

    <div class='row'>
 <span  class='title'>{{ 'website.equipment.config.performance.indicators' | translate }}</span>
    </div>
    <div class='row my-3'>

      <div class='col-width '>
        <mat-card>
          <mat-card-content>
            <div class='card-content'>
              <span>{{currentData.performanceData.freqDemar}}</span>
              <span>{{ 'website.equipment.config.performance.startup_count' | translate }}</span>
            </div>

          </mat-card-content>
        </mat-card>


      </div>
      <div class='col-width '>
        <mat-card>
          <mat-card-content>
        <div class='card-content'>
          <span>{{currentData.performanceData.tpsMinBetweenDemar}}</span>
          <span> {{ 'website.equipment.config.performance.time_btw_stup' | translate }}</span>
        </div>
        </mat-card-content>
        </mat-card>
      </div>
      <div class='col-width '>
        <mat-card>
          <mat-card-content>
        <div class='card-content'>
          <span>{{currentData.performanceData.tpsMinWorking}}</span>
          <span> {{ 'website.equipment.config.performance.min_work_time' | translate }}</span>
        </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class='col-width '>
        <mat-card>
          <mat-card-content>
        <div class='card-content'>
          <span> {{currentData.performanceData.tpsMaxWorking}}</span>
          <span> {{ 'website.equipment.config.performance.max_work_time' | translate }}</span>
        </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class='col-width '>
        <mat-card>
          <mat-card-content>
            <div class='card-content'>
              <span> {{currentData.performanceData.tempsTotal}}</span>
              <span> {{ 'website.equipment.config.performance.work_time' | translate }}</span>

            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>


    <div class='row'  *ngIf='currentData.id!=="centrale" && !chartIsLoading'>
      <div class='col-md-6 col-12'>
        <span class='title  '>Nombre de démarrages centrale</span>
        <br/>
        <br/>
        <highcharts-chart
          class="chart"
          [Highcharts]="Highcharts"
          [options]="chartOptions"
          [(update)]='updateFlag'
          *ngIf="!chartIsLoading"

        ></highcharts-chart>
      </div>
      <div class='col-md-6 col-12 '>
        <span class='title'>Heures de démarrages centrale</span>
        <br/>
        <br/>
        <highcharts-chart
          class="chart"
          [Highcharts]="Highcharts"
          [options]="chartOptionsHours"
          [(update)]='updateFlag'
          *ngIf="!chartIsLoading"

        ></highcharts-chart>
      </div>
      <div class='col-12  mt-3'>
        <span class='title'>Courbe journalière marche du compresseur</span>
        <br/>       <br/>
        <highcharts-chart
          class="chart"
          [Highcharts]="Highcharts"
          [options]="chartOptionsEnergy"
          [(update)]='updateFlag'
          *ngIf="!chartIsLoading"
        ></highcharts-chart>
      </div>
    </div>
  </div>
</mat-dialog-content>





